export const handleSwiperProgressBar = (el, swiper) => {
    const progressEl = el.querySelector('[js-progress]');
    if (!progressEl) return;

    const updateProgress = () => {
        // let progress = swiper.progress;
        const maxIndex = swiper.slides.length - swiper.params.slidesPerView;

        const progress = (swiper.realIndex + 1) / (maxIndex + 1);

        progressEl.style.width = `${Math.min(Math.max(progress, 0), 1) * 100}%`;
    };

    swiper.on('init', updateProgress);
    swiper.on('slideChange', updateProgress);
    swiper.on('resize', updateProgress);

    updateProgress();
};
export const swiperPagination = el => {
    return {
        pagination: {
            bulletActiveClass: 'bg-background-accent! cursor-auto!',
            bulletClass: 'bg-background-secondary',
            el: el,
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="flex-1 cursor-pointer h-[4px] ${className}"></span>`;
            },
        },
        on: {
            slideChange(swiper) {
                const bullets = swiper.pagination.bullets;

                bullets.forEach((bullet, i) => {
                    if (i <= swiper.activeIndex) {
                        bullet.classList.add('bg-background-accent!');
                        bullet.classList.remove('bg-background-secondary');
                    } else {
                        bullet.classList.remove('bg-background-accent!');
                        bullet.classList.add('bg-background-secondary');
                    }
                });
            },
        },
    };
};

export const swiperNavigation = el => {
    return {
        navigation: {
            disabledClass: 'pointer-events-none opacity-50',
            nextEl: el.querySelector('.-next'),
            prevEl: el.querySelector('.-prev'),
        },
    };
};
